import React from "react";
import { Route } from "react-router-dom";

import { IAuthUser } from "../interfaces/IAuthUser";
import { BestCollectors } from "../pages/best-collectors/BestCollectors";
import { Categories } from "../pages/categories/Categories";
import { Category } from "../pages/category/Category";
import { Criteria } from "../pages/criteria/Criteria";
import { CriteriaList } from "../pages/criteriaList/CriteriaList";
import { Exhibition } from "../pages/exhibition/Exhibition";
import { Exhibitions } from "../pages/exhibitions/Exhibitions";
import { JudgmentJudges } from "../pages/judgmentJudges/JudgmentJudges";
import { FollowUp } from "../pages/follow-up/FollowUp";
import { Judgment } from "../pages/judgment/Judgment";
import { JudgmentCriteria } from "../pages/judgmentCriteria/JudgmentCriteria";
import { JudgmentType } from "../pages/judgmentType/JudgmentType";
import { JudgmentTypes } from "../pages/judgmentTypes/JudgmentTypes";
import { Plant } from "../pages/plant/Plant";
import { Plants } from "../pages/plants/Plants";
import { Results } from "../pages/results/Results";
import { Specie } from "../pages/specie/Specie";
import { Species } from "../pages/species/Species";
import { User } from "../pages/user/User";
import { Users } from "../pages/users/Users";

interface AdminRoutesProps {
  user: IAuthUser | null;
}

export const AdminRoutes: React.FC<AdminRoutesProps> = ({ user }) => {
  if (!user || user.typeId !== 1) return null;

  return (
    <>
      {/* User Management */}
      <Route
        path="/users"
        element={<Users pageTitle="Julgamento | Usuários" />}
      />
      <Route
        path="/user/:id"
        element={<User pageTitle="Julgamento | Usuário" />}
      />
      <Route path="/user" element={<User pageTitle="Julgamento | Usuário" />} />

      {/* Categories */}
      <Route
        path="/categories"
        element={<Categories pageTitle="Julgamento | Categorias" />}
      />
      <Route
        path="/category/:id"
        element={<Category pageTitle="Julgamento | Categoria" />}
      />
      <Route
        path="/category"
        element={<Category pageTitle="Julgamento | Categoria" />}
      />

      {/* Criteria */}
      <Route
        path="/criteria-list"
        element={<CriteriaList pageTitle="Julgamento | Critérios" />}
      />
      <Route
        path="/criteria/:id"
        element={<Criteria pageTitle="Julgamento | Critério" />}
      />
      <Route
        path="/criteria"
        element={<Criteria pageTitle="Julgamento | Critério" />}
      />

      {/* Judgment Types */}
      <Route
        path="/judgment-types"
        element={<JudgmentTypes pageTitle="Julgamento | Tipos de Julgamento" />}
      />
      <Route
        path="/judgment-type/:id"
        element={<JudgmentType pageTitle="Julgamento | Tipo de Julgamento" />}
      />
      <Route
        path="/judgment-type"
        element={<JudgmentType pageTitle="Julgamento | Tipo de Julgamento" />}
      />

      {/* Species */}
      <Route
        path="/species"
        element={<Species pageTitle="Julgamento | Espécies" />}
      />
      <Route
        path="/specie/:id"
        element={<Specie pageTitle="Julgamento | Tipo de Espécie" />}
      />
      <Route
        path="/specie"
        element={<Specie pageTitle="Julgamento | Tipo de Espécie" />}
      />

      {/* Exhibitions */}
      <Route
        path="/exhibitions"
        element={<Exhibitions pageTitle="Julgamento | Exposições" />}
      />
      <Route
        path="/exhibition/:id"
        element={<Exhibition pageTitle="Julgamento | Exposição" />}
      />
      <Route
        path="/exhibition"
        element={<Exhibition pageTitle="Julgamento | Exposição" />}
      />
      <Route
        path="/exhibition/:exhibitionId/judgment-judges"
        element={
          <JudgmentJudges pageTitle="Julgamento | Juízes por Julgamento" />
        }
      />
      {/* Judgment */}
      <Route
        path="/judgment/:id"
        element={<Judgment pageTitle="Julgamento | Julgamento" />}
      />
      <Route
        path="/judgment"
        element={<Judgment pageTitle="Julgamento | Julgamento" />}
      />

      {/* Judgment Criteria */}
      <Route
        path="/judgment-criteria/:id"
        element={
          <JudgmentCriteria pageTitle="Julgamento | Critério de julgamento" />
        }
      />
      <Route
        path="/judgment-criteria"
        element={
          <JudgmentCriteria pageTitle="Julgamento | Critério de julgamento" />
        }
      />

      {/* Plants */}
      <Route
        path="/plants"
        element={<Plants pageTitle="Julgamento | Plantas do julgamento" />}
      />
      <Route
        path="/plant/:id"
        element={<Plant pageTitle="Julgamento | Planta" />}
      />
      <Route
        path="/plant"
        element={<Plant pageTitle="Julgamento | Planta" />}
      />

      {/* Results and Follow-up */}
      <Route
        path="/follow-up/:id"
        element={<FollowUp pageTitle="Julgamento | Acompanhamaneto" />}
      />
      <Route
        path="/results/:id"
        element={<Results pageTitle="Julgamento | Resultado" />}
      />
      <Route
        path="/best-collectors/:id"
        element={
          <BestCollectors pageTitle="Julgamento | Melhores Colecionadores" />
        }
      />
    </>
  );
};
